import { createContext, useReducer, useCallback } from 'react';
import AppReducer from './AppReducer';

const initialState = {
  authToken: '',
  permissionLevel: '',
  skill: '',
  campaign: '',
  environment: '',
};

export const GlobalContext = createContext(initialState);

export const GlobalProvider = ({ children }) => {
  const [state, dispatch] = useReducer(AppReducer, initialState);

  // Actions for changing state

  const setAuthToken = useCallback((item) => {
    dispatch({
      type: 'SET_TOKEN',
      payload: item,
    });
  }, []);
  const setEnvironment = useCallback((item) => {
    dispatch({
      type: 'SET_ENVIRONMENT',
      payload: item,
    });
  }, []);
  const setSkill = useCallback((item) => {
    dispatch({
      type: 'SET_SKILL',
      payload: item,
    });
  }, []);
  const setCampaign = useCallback((item) => {
    dispatch({
      type: 'SET_CAMPAIGN',
      payload: item,
    });
  }, []);

  const setPermissionLevel = useCallback((item) => {
    dispatch({
      type: 'SET_PERMISSION_LEVEL',
      payload: item,
    });
  }, []);

  return (
    <GlobalContext.Provider
      value={{
        authToken: state.authToken,
        permissionLevel: state.permissionLevel,
        environment: state.environment,
        skill: state.skill,
        campaign: state.campaign,
        setAuthToken,
        setPermissionLevel,
        setEnvironment,
        setSkill,
        setCampaign,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};
